module.exports = __webpack_public_path__ + "img/lens.cc3c174f.png";